<template>
    <div class="flex flex-row gap-1 items-center justify-between pl-7 pr-2 font-light text-gray-500 min-h-6.5">
        <div class="flex flex-row gap-1 items-center">
            <SubDirectoryIcon class="size-4 text-gray-400 mb-1" />
            {{ $t('override-default-visibility') }}
            <ActivatedToggle
                :is-active="props.visibility === 'Visible'"
                size="Extra-Small"
                @toggle="
                    triggerHideTooltip();
                    emit('toggle-visibility', getToggleValue());
                "
            >
                {{ $t('allocation-variant-visible') }}
            </ActivatedToggle>
        </div>

        <div
            v-if="visibility === 'Invisible'"
            class="flex flex-row items-center font-light gap-1 text-yellow-800 bg-yellow-100 pl-2 pr-2.5 rounded-full leading-none py-1 min-w-max ml-2 text-sm"
        >
            <WarningIcon class="size-4.5 text-yellow-600" /> {{ $t('some-allocations-in-timeline-range-hidden') }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { provide, ref } from 'vue';
import ActivatedToggle from '../ActivatedToggle/ActivatedToggle.vue';
import SubDirectoryIcon from '../Icon/SubDirectoryIcon.vue';
import WarningIcon from '../Icon/WarningIcon.vue';
import { triggerHideTooltipKey } from '../Tooltip/injectionKeys';

export type AllocationVariantOverrideVisibility = 'Visible' | 'Invisible';

type AllocationVariantVisibilityOverrideProps = {
    visibility: 'Visible' | 'Invisible';
};

type AllocationVariantVisibilityOverrideEmits = {
    (e: 'toggle-visibility', v: AllocationVariantOverrideVisibility): void;
};

const props = defineProps<AllocationVariantVisibilityOverrideProps>();
const emit = defineEmits<AllocationVariantVisibilityOverrideEmits>();

function getToggleValue() {
    switch (props.visibility) {
        case 'Invisible':
            return 'Visible';
        case 'Visible':
            return 'Invisible';
    }
}

// This is used to force close the Tooltip after clicking the button
const triggerHideTooltipKeyCounter = ref(0);
provide(triggerHideTooltipKey, triggerHideTooltipKeyCounter);

function triggerHideTooltip() {
    triggerHideTooltipKeyCounter.value = triggerHideTooltipKeyCounter.value + 1;
}
</script>
